import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import AmenitiesList from "components/Amenities/AmenitiesList";
import AmenitiesModel from "components/Amenities/Model/AmenitiesModel";
import DialogEditAmenities from "components/Amenities/Model/DialogEditAmenities";
import { Grid } from "@mui/material";
import EnableDecebleAmenities from "components/Amenities/EnableDesableAmenities";
import { AmenitiesTableApi } from "stores/AmenitiesTableStore/AmenitiesTableApi";

class AmenitiesContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openEdit: false,
      amenitiesname: "",
      id: null,
      AddAmenitiesConfirmDaialog: false,
      AddAmenitiesStatus: "",
      AddAmenitiesStatusId: "",
    };
  }

  componentDidMount() {
    this.props.getAmenitiesTableAction();
    // await this.props.PostAmenitiesAction();
  }

  handleClickopenEdit = (id, amenitiesname) => {
    this.setState({
      openEdit: true,
      id: `${id}`,
      amenitiesname: amenitiesname,
    });
    // onClickEdit();
  };

  handleOnChange = (e) => {
    this.setState({ amenitiesname: e.target.value });
  };

  handleClickSubmit = async () => {
    const { id, amenitiesname } = this.state;
    if (amenitiesname) {
      await this.props.UdateAmenitiesAction({ id, name: amenitiesname });
      this.props.getAmenitiesTableAction();
      this.setState({ openEdit: false });
    }
  };

  handleEditUpdateAmanity = () => {
    this.setState({ openEdit: false });
  };

  submitAmenities = async (id) => {
    var res = await AmenitiesTableApi.postAmenitiesApi(id);

    if (res.status === 1) {
      this.handleClickOpen();
    }

    this.props.getAmenitiesTableAction();
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  handleClickOpen = () => {
    this.setState({ open: true });
  };

  AddhandleAmenitiesClose = () => {
    this.setState({ AddAmenitiesConfirmDaialog: false });
  };

  handleStatusAddAmenities = (id, status) => {
    this.setState({
      AddAmenitiesConfirmDaialog: true,
      AddAmenitiesStatus: status,
      AddAmenitiesStatusId: id,
    });
  };

  AddhandleEnableClickAmenities = async () => {
    const status = this.state.AddAmenitiesStatus;
    const id = this.state.AddAmenitiesStatusId;

    if (status === 1) {
      await AmenitiesTableApi.AmenitiesEnableDisableApi({ id, status: 0 });
      this.setState({ AddAmenitiesStatus: 0 });
      this.props.getAmenitiesTableAction();
    } else {
      await AmenitiesTableApi.AmenitiesEnableDisableApi({ id, status: 1 });
      this.props.getAmenitiesTableAction();
    }

    this.setState({ AddAmenitiesConfirmDaialog: false });
  };

  render() {
    const data = this.props?.AmenitiesTableList?.result;

    return (
      <>
        <Grid item xs={12}>
          <Paper sx={{ p: 3, mt: 3.5 }}>
            <Stack spacing={3} mt={3.5}>
              <AmenitiesList
                data={data}
                onClickModel={this.handleClickOpen}
                handleClickUpdate={this.handleClickopenEdit}
                submitAmenities={(val) => this.submitAmenities(val)}
                handleStatusAddAmenities={this.handleStatusAddAmenities}
                isloadingAmenitiesTable={
                  this.props.isloadingAmenitiesTable?.isLoading
                }
              />

              <AmenitiesModel
                handleClose={this.handleClose}
                open={this.state.open}
              />
              <DialogEditAmenities
                handleClose={this.handleEditUpdateAmanity}
                open={this.state.openEdit}
                data={this.state.amenitiesname}
                handleOnChange={this.handleOnChange}
                handleClickSubmit={this.handleClickSubmit}
              />

              <EnableDecebleAmenities
                open={this.state.AddAmenitiesConfirmDaialog}
                handleEnable={this.AddhandleEnableClickAmenities}
                handleclose={this.AddhandleAmenitiesClose}
                AddvehicleStatus={this.state.AddAmenitiesStatus}
              />
            </Stack>
          </Paper>
        </Grid>
      </>
    );
  }
}

export default AmenitiesContainer;
